import React from "react";
import Button from "../../Button";

const SidebarToggle = ({
  isFullScreen,
  hideListChannel,
  isOnDemandType,
  showListButton,
  translate,
  isRecording,
  onClickHandler,
}) => {
  if (hideListChannel === true || isFullScreen) {
    return null;
  }

  return (
    <Button
      buttonStyles="list-button show-side-panel"
      label={
        isOnDemandType
          ? showListButton
            ? translate(isRecording ? "recorded_episodes" : "episode_list")
            : translate("details")
          : translate("live_guide")
      }
      onClickHandler={onClickHandler}
      tabIndex="-1"
    />
  );
};

export default SidebarToggle;
